import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Après un déploiement, un navigateur peut garder l'ANCIENNE page en mémoire et
// réclamer des morceaux de code qui n'existent plus → écran noir (vécu par le
// propriétaire, 2026-10-16). On détecte ce cas précis et on recharge la page une
// seule fois : le navigateur repart sur la version fraîche, tout seul.
const _estErreurDeMorceau = (msg) =>
  /ChunkLoadError|Loading chunk|dynamically imported module|Failed to fetch/i.test(msg || "");
window.addEventListener("error", (e) => {
  if (_estErreurDeMorceau(e.message || String(e.error)) && !sessionStorage.getItem("mt_reload_maj")) {
    sessionStorage.setItem("mt_reload_maj", "1");
    window.location.reload();
  }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  if (_estErreurDeMorceau(String(e.reason)) && !sessionStorage.getItem("mt_reload_maj")) {
    sessionStorage.setItem("mt_reload_maj", "1");
    window.location.reload();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
